var termsCheckbox = function(terms, submit, check, form) {

		console.log(check);
		console.log(submit);

	var check = check;
	var checkSpan = document.querySelector(check);

	if (checkSpan && typeof checkSpan !== 'undefined') {
		var terms = terms;

		var submit = submit;

		/*
		if ( document.querySelector('#submit') ) {
			submit = '#submit';
		} else if ( document.querySelector('.salesforce-form input[type="submit"]') ) {
			submit = '.salesforce-form input[type="submit"]';
		} else if ( document.querySelector('.contacts-quick-form input[type="submit"]') ) {
			submit = '.contacts-quick-form input[type="submit"]';
		} else if ( document.querySelector('.stage-form input[type="submit"]') ) {
			submit = '.stage-form input[type="submit"]';
		}
		*/

		var agreeActive = 'agree-check-show';
		var agreeInactive = 'agree-inactive';
		var submitDisabled = 'submit-disabled';
		var termsCheck = document.querySelector(terms);
		var submitButton = document.querySelector(submit);
		termsCheck.value = -1;
		submitButton.classList.add(submitDisabled);


		termsCheck.addEventListener('change', function(e) {
			var self = e.target;
			var checkButton = document.querySelector(check);
			var submitButton = document.querySelector(submit);
			self.value *= -1;
			if(self.value === '1'){
				submitButton.classList.remove(submitDisabled);
				checkButton.classList.remove(agreeInactive);
				checkButton.classList.add(agreeActive);
			} else {
				submitButton.classList.add(submitDisabled);
				checkButton.classList.remove(agreeActive);
			}
		});

		submitButton.addEventListener('click', function() {
			var checkButton = document.querySelector(check);
			if(termsCheck.value !== '1') {
				checkButton.classList.add(agreeInactive);
			}
		});

		form.addEventListener('submit', function(e) {
			var termsCheck = document.querySelector(terms);
			console.log(termsCheck);
			if(termsCheck.value === '1') {
				return true;
			} else {
				e.preventDefault();
				return false;
			}
		});
	}
};

